import { LAST_SLOT, MINUTES_IN_DAY } from '../timePicker/constants';
import { TimeRange } from './types';

export const changeStart = ({ start, end }: TimeRange, nextStart: number): TimeRange => {
  const duration = end - start;
  const clampedStart = Math.max(0, Math.min(nextStart, LAST_SLOT));
  return { start: clampedStart, end: Math.min(clampedStart + duration, MINUTES_IN_DAY - 1) };
};

export const changeEnd = ({ start }: TimeRange, nextEnd: number): TimeRange => ({
  start,
  end: nextEnd <= start ? Math.min(start + 15, MINUTES_IN_DAY - 1) : nextEnd,
});
